import { FC, ReactNode } from 'react';
import { Users, Contact as FileContract, Laptop, Settings, User, Building2, LayoutDashboard, Rss, LucideProps } from 'lucide-react';

// Definir a estrutura dos itens de menu
export interface MenuItemConfig {
  text: string;
  icon: React.ComponentType<LucideProps>;
  path: string;
  requiredPermission?: string; // Permissão necessária para ver este item
}

// Definir todos os itens de menu possíveis com suas permissões necessárias
// Mantenha a ordem desejada para o redirecionamento
export const allMenuItems: MenuItemConfig[] = [
  { text: 'Dashboards', icon: LayoutDashboard, path: '/dashboards', requiredPermission: 'dashboard' },
  { text: 'Feed de Pessoas', icon: Rss, path: '/person-feed', requiredPermission: 'pessoas' }, // TODO: Definir permissão
  { text: 'Gestão de Contratos', icon: FileContract, path: '/contracts', requiredPermission: 'gestao_de_contratos' },
  { text: 'Pessoas', icon: Users, path: '/pessoas', requiredPermission: 'pessoas' },
  { text: 'Empresas', icon: Building2, path: '/empresas', requiredPermission: 'empresas' },
  { text: 'Perfil', icon: User, path: '/profiles', requiredPermission: 'perfil' },
  { text: 'Equipamentos', icon: Laptop, path: '/equipment', requiredPermission: 'equipamentos' },
  { text: 'Parâmetros', icon: Settings, path: '/parametros', requiredPermission: 'parametros' }
]; 